import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContent,[_c(VRow,[_c(VCol),_c(VCol,[_c('RequestPasswordResetForm',{attrs:{"reset":_vm.reset,"resetRequested":_vm.resetRequested,"busy":_vm.busy},on:{"usernameChanged":function($event){return _vm.usernameChanged($event)}}})],1),_c(VCol)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }